<template>
    <div class="card">
        <div class="card__content">
            <p>
                <label class="big-label"><strong>{{ $t('message.contenedor') }}: </strong><a target="_blank" :href="path">{{ contenedor.number }}</a></label>
                <label class="big-label"><strong>{{ $t('message.patio') }}:</strong> {{ contenedor.yard !== null?contenedor.yard.name:'' }}</label>
                <label class="big-label"><strong>{{ $t('message.cliente') }}:</strong> {{ contenedor.customer !== null && contenedor.customer !== undefined?contenedor.customer.name:'' }} [{{ contenedor.customer_code }}]</label>
                <label class="big-label"><strong>Gate IN:</strong> {{ contenedor.gate_in_date }}</label>
            </p>
            <table-bar :rows="[
                (contenedor.garita_finalizada === 'S'),
                (((contenedor.is_caja === 'S' && contenedor.inspection_b === 'S') || contenedor.is_caja !== 'S') && ((contenedor.is_maquina === 'S' && contenedor.inspection_m === 'S') || contenedor.is_maquina !== 'S')) && !(contenedor.is_caja ==='N' && contenedor.is_maquina === 'N'),
                (((contenedor.is_caja === 'S' && contenedor.estimado_b === 'S') || contenedor.is_caja !== 'S') && ((contenedor.is_maquina === 'S' && contenedor.estimado_m === 'S') || contenedor.is_maquina !== 'S')) && !(contenedor.is_caja ==='N' && contenedor.is_maquina === 'N'),
                (contenedor.is_caja === 'S' && contenedor.aprobado_b === 'S') && (contenedor.is_maquina === 'N' || (contenedor.is_maquina === 'S' && contenedor.aprobado_m === 'S')),
                (((contenedor.is_caja === 'S' && contenedor.repaired  === 'S') || contenedor.is_caja !== 'S') && ((contenedor.is_maquina === 'S' && contenedor.repaired_m === 'S') || contenedor.is_maquina !== 'S')) && !(contenedor.is_caja === 'N' && contenedor.is_maquina === 'N'),
                contenedor.kim_salida === 'S' || contenedor.status === 'T'
            ]"></table-bar>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        contenedor : {
            type : Object,
            required : false,
            default : function () {
                return {
                    number : ''
                };
            }
        }
    },
    data : function () {
        return {
            path : url + '/contenedores/' + this.contenedor.number
        };
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/ItemDashboard.vue